import React, {useState, useEffect} from "react";
import {FaTimes, FaSearch} from "react-icons/fa";
import Url from "../../../url/Url";
import {useContext} from "react";
import {SafeAreaContext} from "../../../App";
import ImageWithLoader from "../../../components/imageLoader/ImageWithLoader";
import Currency from "../../../services/Currency";


export default function SelectorToggle({
                                           isOpen,
                                           onClose,
                                           showSelectorToggle,
                                           setShowSelectorToggle,
                                           allSymbols = [],
                                           loading,
                                           setSearch,
                                           search,
                                           setFilter,
                                           filter,
                                               onSaved,

                                           filterValues
                                       }) {
    const {setSafeAreaColor} = useContext(SafeAreaContext);

    useEffect(() => {
        setSafeAreaColor({background: 'rgba(0, 0, 0, 0.5)'});
    }, []);
    const [selected, setSelected] = useState(new Set());


    const toggleSymbol = (symbol) => {
        setSelected((prev) => {
            const next = new Set(prev);
            if (next.has(symbol)) next.delete(symbol);
            else next.add(symbol);
            return next;
        });
    };


    const [btnLoading, setBtnLoading] = useState(false);

  async function AddSymbol() {
    setBtnLoading(true);

    try {
        await Currency.addSymbol({
            symbols: Array.from(selected)
        });

        await onSaved();
        onClose(false);

    } catch (error) {
        console.error('Error adding symbols:', error);
    } finally {
        setBtnLoading(false);
    }
}

    useEffect(() => {
        const saved = new Set(
            allSymbols
                .filter((s) => s.isSaved)
                .map((s) => s._id)
        );

        setSelected(saved);
    }, [allSymbols]);

    if (!isOpen) {
        return null
    }

    return (
        <div className={`fixed inset-0 bg-black/50 z-50 flex items-end `}>
            <div
                className={`bg-white w-full rounded-t-3xl max-h-[85vh] min-h-[60vh] flex flex-col shadow-2xl ${showSelectorToggle ? 'animate-slideOutToUp' : 'animate-slideOutToBottom'}`}>
                {/* Header */}
                <div className="p-6 border-b border-border flex items-center justify-between">
                    <h3 className="text-xl font-bold text-text-primary">Select Symbols</h3>
                    <button
                        onClick={() => {
                            setShowSelectorToggle(false);
                            setTimeout(() => {
                                onClose(false)
                            }, 300)
                        }}
                        className="w-10 h-10 bg-gray-100 rounded-xl flex items-center justify-center"
                    >
                        <FaTimes className="text-text-secondary"/>
                    </button>
                </div>

                {/* Description and controls */}
                <div className="p-6 space-y-4">
                    <p className="text-text-secondary text-sm">
                        Choose which symbols to display on your dashboard
                    </p>

                    {/* Search */}
                    <div className="relative text-[#808080] ">
            <span className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <FaSearch className="text-text-secondary"/>
            </span>
                        <input
                            type="text"
                            placeholder="Search symbols..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="w-full pl-12 pr-4 py-3 bg-gray-50 rounded-xl text-text-primary placeholder:text-text-secondary focus:ring-2 focus:ring-primary transition-all"
                        />
                    </div>

                    {/* Filter Buttons */}
                    <div className="flex flex-wrap gap-2">
                        {filterValues.map((f) => (
                            <button
                                key={f}
                                onClick={() => setFilter(f)}
                                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                                    filter === f
                                        ? "bg-gradient-to-r from-primary to-primary-light text-white"
                                        : "bg-gray-100 text-text-secondary hover:bg-gray-200"
                                }`}
                            >
                                {f.charAt(0).toUpperCase() + f.slice(1)}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Symbols List */}
                <div className="flex-1 overflow-y-auto px-6 pb-4 space-y-3">
                    {loading ?
                        <p className={'text-gray-500 w-full text-center'}>Loading...</p> : allSymbols.length > 0 ?
                            allSymbols.map((s) => (
                                <div
                                    key={s.symbol}
                                    className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors"
                                >
                                    <div className="flex items-center space-x-4">
                                        <div className="w-12 h-12 rounded-xl shadow-sm">
                                            <ImageWithLoader
                                                src={`${Url}${s?.image?.path}`}
                                                alt={s.name}>
                                            </ImageWithLoader>
                                        </div>

                                        <div>
                                            <div className="font-semibold text-text-primary">
                                                {s.symbol}
                                            </div>
                                            <div className="text-sm text-text-secondary">{s.name}</div>
                                            <div className="text-xs text-text-secondary capitalize">
                                                {s.category}
                                            </div>
                                        </div>
                                    </div>
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            checked={selected.has(s._id)}
                                            onChange={() => toggleSymbol(s._id)}
                                            className="sr-only peer"
                                        />
                                        <div
                                            className={`w-11 h-6 bg-gray-200 rounded-full peer-focus:ring-4 peer-focus:ring-primary/20 peer-checked:bg-primary relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full`}/>
                                    </label>
                                </div>
                            ))
                            :
                            <p className={'text-sm text-gray-900 w-full text-center'}>
                                No Symbol found.
                            </p>
                    }

                </div>

                {/* Apply Button */}
                <div className="p-6 pt-4 border-t border-border bg-white flex-shrink-0">
                    <button
                        disabled={btnLoading}
                        onClick={AddSymbol}
                        className="w-full bg-gradient-to-r from-primary to-primary-light  text-white py-3 rounded-xl font-semibold disabled:opacity-60"
                    >
                        {btnLoading ? 'Please wait...' : 'Apply Selection'}
                    </button>
                </div>
            </div>
        </div>
    );
}